import React, { lazy, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  BUSINESS,
  BUSINESS_CASH_MANAGEMENT,
  BUSINESS_INSURANCE,
  BUSINESS_DEPOSIT,
  BUSINESS_CASH_MANAGEMENT_SOLUTION,
  BUSINESS_LOAN_SOLUTION,
  BUSINESS_INVESTMENT,
  BUSINESS_FOREX_SERVICE,
  BUSINESS_NEWS,
  BUSINESS_COMPLETE_SOLUTION,
  BUSINESS_THANK_YOU,
  BUSINESS_NEWS_BY_ID,
  BUSINESS_LOAN_SOLUTION_APPLICATION_FORM,
  BUSINESS_EWBILLERS,
  BUSINESS_EASTWEST_EASYBIZ,
} from "./paths";
import CashManagementBusinessFormContextProvider from "Components/context/CashManagementBusinessFormContext";

const CashManagement = lazy(() => import("Components/CashManagement"));
const CashManagementSolution = lazy(() =>
  import("pages/Business/CashManagementSolution")
);
const Deposit = lazy(() => import("pages/Business/Deposit"));
const EasyBiz = lazy(() => import("pages/Business/EasyBiz")); //! NEW PAGE EASYBIZ
const ForexService = lazy(() => import("pages/Business/ForexService"));
const Insurance = lazy(() => import("pages/Business/Insurance"));
const Investment = lazy(() => import("pages/Business/Investment"));
const Loan = lazy(() => import("pages/Business/Loan"));
const Business = lazy(() => import("pages/Business/Business"));
const News = lazy(() => import("pages/Business/News"));
const NewsPage = lazy(() => import("pages/Business/News/NewsPage"));
const BusinessThankyou = lazy(() => import("pages/Business/BusinessThankYou"));
const CompleteSolution = lazy(() => import("pages/Business/CompleteSolution"));
const BusinessLoansSolutionApplication = lazy(() =>
  import("pages/Forms/BusinessLoanSolutionsApplication")
);
const BusinessRoutes = () => {
  return (
    <CashManagementBusinessFormContextProvider>
      <Switch>
        <Route
          path={BUSINESS_LOAN_SOLUTION_APPLICATION_FORM}
          component={BusinessLoansSolutionApplication}
        />
        <Route
          path={BUSINESS_CASH_MANAGEMENT_SOLUTION}
          component={CashManagementSolution}
        />
        <Route path={BUSINESS_DEPOSIT} component={Deposit} />
        <Route path={BUSINESS_EASTWEST_EASYBIZ} component={EasyBiz} /> //! NEW PAGE EASYBIZ
        <Route path={BUSINESS_FOREX_SERVICE} component={ForexService} />
        <Route path={BUSINESS_INSURANCE} component={Insurance} />
        <Route path={BUSINESS_INVESTMENT} component={Investment} />
        <Route path={BUSINESS_LOAN_SOLUTION} component={Loan} />
        <Route path={BUSINESS_NEWS} component={News} />
        <Route path={BUSINESS_COMPLETE_SOLUTION} component={CompleteSolution} />
        <Route path={BUSINESS_THANK_YOU} component={BusinessThankyou} />
        <Route path={BUSINESS_NEWS_BY_ID} component={NewsPage} />
        <Route path={BUSINESS_CASH_MANAGEMENT} component={CashManagement} />
        <Route path={BUSINESS} component={Business} />

        <Route path="*" component={() => <Redirect to={BUSINESS} />} />
      </Switch>
    </CashManagementBusinessFormContextProvider>
  );
};

export default BusinessRoutes;
